module.exports = __webpack_public_path__ + "img/izamba.975dd6ad.jpg";